import {useFormatNumber} from 'platform/locale';

import {isNotNil} from 'ramda';

export const useFloatNumberFormatter = () => {
  const formatNumber = useFormatNumber();

  return (value?: string | null) => (isNotNil(value) ? formatNumber(parseFloat(value)) : null);
};
